import { useState } from 'react';
import { Code2, Menu, X } from 'lucide-react';
import { Reveal } from '../hooks/useReveal.tsx';
import { MeshText } from './MeshText';

export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Projects', id: 'projects', count: '5' },
    { name: 'About', id: 'about' },
    { name: 'Skills', id: 'skills' },
    { name: 'Contact', id: 'contact' },
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 w-full z-50 border-b border-white/15">
      <div className="px-5 sm:px-8 md:px-12">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <Reveal delay={0}>
            <button
              onClick={scrollToTop}
              className="flex items-center gap-2 hover:opacity-80 transition-opacity"
            >
              <Code2 size={24} strokeWidth={1.5} className="text-white" />
              <div className="h-[24px] w-[60px]">
                <MeshText
                  text="paras"
                  color="#ffffff"
                  fontFamily="Inter"
                  fontWeight={500}
                  fontSize={20}
                  colorSplit={true}
                  splitColors={['#61dafb', '#ff40c0']}
                  force={14}
                />
              </div>
            </button>
          </Reveal>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8 lg:gap-10">
            {navLinks.map((link, index) => (
              <Reveal key={link.id} delay={100 + index * 100}>
                <button
                  onClick={() => scrollToSection(link.id)}
                  className="flex items-center gap-1"
                >
                  <div className="h-[16px] w-[80px]">
                    <MeshText
                      text={link.name}
                      color="rgba(255,255,255,0.85)"
                      fontFamily="Inter"
                      fontWeight={400}
                      fontSize={14}
                      colorSplit={true}
                      splitColors={['#61dafb', '#40ff80']}
                      force={10}
                    />
                  </div>
                </button>
              </Reveal>
            ))}
          </div>

          {/* CTA Button */}
          <Reveal delay={500} className="hidden md:block">
            <a
              href="/Resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-md border border-white/20 bg-white/15 backdrop-blur-md px-4 py-2 text-xs sm:px-5 sm:text-sm text-white hover:bg-white/25 transition-colors duration-300"
            >
              View Resume
            </a>
          </Reveal>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-white/85 hover:text-white transition-colors"
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          isMenuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-5 py-4 bg-black/80 backdrop-blur-md border-t border-white/10">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className="block w-full text-left py-3 text-white/85 hover:text-white transition-colors"
            >
              {link.name}
              
            </button>
          ))}
          <a
            href="/Resume.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-left py-3 text-white/85 hover:text-white transition-colors"
          >
            View Resume
          </a>
        </div>
      </div>
    </nav>
  );
}
